import { Link } from 'react-router-dom'
import { getMyOrgPractices } from '../../api/staff'
import { ErrorBox } from '../ui/Card'
import { useFetch } from '../../hooks/useFetch'
import { thClass, tdClass, tbodyHoverClass } from '@/lib/tableStyles'
import { DashboardWidgetCard } from './DashboardWidgetCard'

export function OrgPracticesWidget() {
  const { data, loading, error } = useFetch(() => getMyOrgPractices(), [])
  const practices = data ?? []

  return (
    <DashboardWidgetCard title="Your Practices">
      {loading ? (
        <div className="p-6 text-text-3 text-[0.875rem]">Loading…</div>
      ) : error ? (
        <div className="px-5 py-4"><ErrorBox className="mb-0">Could not load practices.</ErrorBox></div>
      ) : practices.length === 0 ? (
        <div className="px-5 py-6 text-text-3 text-[0.875rem]">No practices in your organisation yet.</div>
      ) : (
        <table className="w-full border-collapse text-[0.875rem]">
          <thead>
            <tr>
              <th className={thClass}>Practice</th>
              <th className={thClass}>Organisation</th>
              <th className={`${thClass} text-right`}></th>
            </tr>
          </thead>
          <tbody className={tbodyHoverClass}>
            {practices.map(p => (
              <tr key={p.id}>
                <td className={`${tdClass} font-medium`}>{p.name}</td>
                <td className={`${tdClass} text-text-2`}>{p.organisation_name ?? '—'}</td>
                <td className={`${tdClass} text-right`}>
                  <Link to={`/practices/${p.id}/staff`} className="text-accent font-medium text-[0.8rem] no-underline hover:underline">
                    Manage Staff →
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </DashboardWidgetCard>
  )
}
